import React, { useRef, useState } from "react";
import { cn } from "../../../lib/utils";
import CrmButton from "./CrmButton";

/**
 * "Drop CSV / XLSX" + Browse (wireframe step 1). Drag-and-drop and the file picker call
 * the same `onFile(file)`; only the first file is taken.
 */
export default function Dropzone({ prompt, browseLabel, accept, onFile, disabled = false, testId, inputTestId }) {
  const input = useRef(null);
  const [over, setOver] = useState(false);
  const take = (files) => {
    const file = files && files[0];
    if (file && !disabled) onFile(file);
  };
  return (
    <div
      data-testid={testId}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); take(e.dataTransfer?.files); }}
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed px-6 py-8 text-center",
        over ? "border-eh-sage-deep bg-eh-cream" : "border-eh-border",
        disabled && "opacity-50",
      )}
    >
      <p className="text-sm text-eh-ink">{prompt}</p>
      <CrmButton variant="outline" size="sm" disabled={disabled} onClick={() => input.current?.click()}>{browseLabel}</CrmButton>
      <input
        ref={input}
        type="file"
        accept={accept}
        className="sr-only"
        tabIndex={-1}
        aria-hidden="true"
        data-testid={inputTestId}
        onChange={(e) => { take(e.target.files); e.target.value = ""; }}
      />
    </div>
  );
}
